function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#f37320;fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0.042)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  fill: "none",
  width: 36,
  height: 36,
  transform: "translate(0 -0.042)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.026 11.556)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  fill: "#F37320",
  fillRule: "evenodd",
  d: "M201.906,616.214l3.252,3.252,2.283-2.283L200.258,610l-2.283,2.283.035.035-4.866,4.865,2.283,2.283,3.252-3.252V626.3h3.229Z",
  transform: "translate(-193.143 -610)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.875 6.874)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  fill: "#F37320",
  fillRule: "evenodd",
  d: "M188,631v4.036h2.422v-1.614h17.758v1.614H210.6V631Z",
  transform: "translate(-188 -631)"
})));

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, "\n      {/* ", _ref2, " */}\n      ", _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.be98b5212d47221d2697578e625e7b12.svg";
export { ForwardRef as ReactComponent };